import actions from './actions';

const makeResetHandlers = (modelName, actions) => ({
  [actions.resetAll]: (state, action, session) => {
    const { [modelName]: Model } = session;
    Model.all().delete();

    for (const record of action.payload) Model.create(record, { parse: true });
  },
});

export const makeBasicHandlers = (modelName, actions) => ({
  ...makeResetHandlers(modelName, actions),
  [actions.create]: (state, action, session) => {
    const { [modelName]: Model } = session;

    Model.create(action.payload, { parse: true });
  },
  [actions.upsert]: (state, action, session) => {
    const { [modelName]: Model } = session;

    Model.upsert(action.payload, { parse: true });
  },
  [actions.update]: (state, action, session) => {
    const { [modelName]: Model } = session;
    const { primaryKey, props } = action.payload;

    const model = Model.withPrimaryKey(primaryKey);
    if (!model) return;

    model.update(props, { parse: true });
  },
  [actions.destroy]: (state, action, session) => {
    const { [modelName]: Model } = session;

    const model = Model.withPrimaryKey(action.payload);
    if (!model) return;

    model.delete();
  },
});

const genderHandlers = {
  ...makeResetHandlers('Gender', actions.gender),
};

const liftHandlers = {
  ...makeResetHandlers('Lift', actions.lift),
};

const bodyweightCategoryHandlers = {
  ...makeResetHandlers('BodyweightCategory', actions.bodyweightCategory),
  ...makeBasicHandlers('BodyweightCategory', actions.bodyweightCategory),
};

const ageGroupHandlers = {
  ...makeResetHandlers('AgeGroup', actions.ageGroup),
};

// TODO: Have locked property for the default contests, disallow edits?

const eventHandlers = {
  ...makeResetHandlers('Event', actions.event),
};

const contestHandlers = {
  ...makeResetHandlers('Contest', actions.contest),
  ...makeBasicHandlers('Contest', actions.contest),
};

const teamHandlers = {
  ...makeBasicHandlers('Team', actions.team),
};

const entryHandlers = {
  ...makeBasicHandlers('Entry', actions.entry),
  /*
  [actions.entry.setSession]: (state, action, session) => {
    const { primaryKey, sessionPrimaryKey } = action.payload;
    const { Entry, Session } = session;

    const entry = Entry.withPrimaryKey(primaryKey);
    if (!entry) return;

    entry.session = sessionPrimaryKey
      ? Session.withPrimaryKey(sessionPrimaryKey)
      : null;
  },

  [actions.entry.setWeighInData]: (state, action, session) => {
    const { Entry, WeighInDatum, Lift } = session;
    const { primaryKey, startingDeclarations = {}, ...props } = action.payload;

    const entry = Entry.withPrimaryKey(primaryKey);
    if (!entry) return;

    entry.update(props);

    const lifts = Lift.all().toModelArray();
    for (const lift of lifts) {
      const weight = startingDeclarations[lift.uuid];

      if (weight) WeighInDeclaration.upsert({ entry, lift, weight });
      else WeighInDeclaration.filter({ entry, lift }).delete();
    }
  },
  */
};

const lotHandlers = {
  ...makeResetHandlers('Lot', actions.lot),
};

const groupHandlers = {
  ...makeBasicHandlers('Group', actions.group),
};

const sessionHandlers = {
  ...makeBasicHandlers('Session', actions.session),
};

const weighInDatumHandlers = {
  ...makeResetHandlers('WeighInDatum', actions.weighInDatum),
  ...makeBasicHandlers('WeighInDatum', actions.weighInDatum),
};

const weighInDeclarationHandlers = {
  ...makeResetHandlers('WeighInDeclaration', actions.weighInDeclaration),
  ...makeBasicHandlers('WeighInDeclaration', actions.weighInDeclaration),
};

const protocolHandlers = {
  ...makeBasicHandlers('Protocol', actions.protocol),
};

const athleteHandlers = {
  ...makeBasicHandlers('Athlete', actions.athlete),

  /*
  [actions.athlete.declareWeight]: (state, action, session) => {
    const { Athlete, Lift, Declaration } = session;
    const {
      primaryKey,
      liftPrimaryKey,
      attemptNumber,
      weight,
    } = action.payload;

    const athlete = Athlete.withPrimaryKey(primaryKey);
    const lift = Lift.withPrimaryKey(liftPrimaryKey);
    if (!athlete || !lift) return;

    const lastDeclaration = maxBy(
      athlete.declarations.filter({ lift, attemptNumber }).toRefArray(),
      'changeNumber',
    );

    const changeNumber = get(lastDeclaration, 'changeNumber', 0) + 1;

    // TODO: Purpose normalization function partially?
    Declaration.create({ athlete, lift, attemptNumber, changeNumber, weight });
  },

  [actions.athlete.setDecision]: (state, action, session) => {
    const { Athlete, Lift, Attempt } = session;
    const {
      primaryKey,
      liftPrimaryKey,
      attemptNumber,
      decision,
    } = action.payload;

    const athlete = Athlete.withPrimaryKey(primaryKey);
    const lift = Lift.withPrimaryKey(liftPrimaryKey);
    if (!athlete || !lift) return;

    const lastDeclaration = maxBy(
      athlete.declarations.filter({ lift, attemptNumber }).toRefArray(),
      'changeNumber',
    );
    if (!lastDeclaration) return;

    const { weight } = lastDeclaration;
    Attempt.create({
      athlete,
      lift,
      number: attemptNumber,
      weight,
      decision,
    });
  },
  */
};

const declarationHandlers = {
  ...makeBasicHandlers('Declaration', actions.declaration),
};

const attemptHandlers = {
  ...makeBasicHandlers('Attempt', actions.attempt),
};

const decisionHandlers = {
  ...makeBasicHandlers('Decision', actions.decision),
};

const handlers = {
  ...genderHandlers,
  ...liftHandlers,
  ...bodyweightCategoryHandlers,
  ...ageGroupHandlers,
  ...eventHandlers,
  ...contestHandlers,
  ...teamHandlers,
  ...entryHandlers,
  ...lotHandlers,
  ...groupHandlers,
  ...sessionHandlers,
  ...weighInDatumHandlers,
  ...weighInDeclarationHandlers,
  ...protocolHandlers,
  ...athleteHandlers,
  ...declarationHandlers,
  ...attemptHandlers,
  ...decisionHandlers,
};

export default handlers;



// WEBPACK FOOTER //
// ./src/orm/handlers.js